import qs from 'qs';
import { Tag } from '@/types/tags';
import request from '@/lib/request';

type Response = {
  data: Tag[];
  meta: any;
};

// export default async function getTags(options?: { locale: string }) {
//   return await request<Response>(
//     'GET',
//     `/api/tags?${
//       options &&
//       queryString.stringify({
//         locale: options.locale,
//         populate: '*',
//       })
//     }`,
//     {
//       cache: 'no-store',
//     }
//   );
// }

export default async function getTags(options?: {
  locale: string;
  baseUrl?: boolean;
}) {
  const query = qs.stringify(
    {
      locale: options?.locale,
      cache: 'no-store',
    },
    {
      encodeValuesOnly: true,
    }
  );

  return await request<Response>('GET', `/api/tags?${query}`, {
    baseUrl: options?.baseUrl,
  });
}
